import { render, staticRenderFns } from "./VkSmmWidget.vue?vue&type=template&id=46b9713e&scoped=true&"
import script from "./VkSmmWidget.vue?vue&type=script&lang=js&"
export * from "./VkSmmWidget.vue?vue&type=script&lang=js&"
import style0 from "./VkSmmWidget.vue?vue&type=style&index=0&id=46b9713e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9713e",
  null
  
)

export default component.exports